import { Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { IPlan, planDurationList } from '@common/interfaces';

@Component({
  selector: 'app-cards',
  templateUrl: './card.html',
  styleUrls: ['./card.scss'],
})
export class cardsComponent implements OnInit {
  @Input() assets: any;
  @Input() accessory:any;
  @Input() hover: string = '';
  @ViewChildren('asset') asset!: QueryList<ElementRef>;
  @Input() plan?: IPlan;
  @Output() editPlan= new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(){
    if(this.hover){
      this.asset.forEach((asset) => {
        asset.nativeElement.style.cursor = 'default';
      })
    }
  }
  
  getTenure(days: number){
    return planDurationList.find((duration)=>duration.days===days)?.name ?? 'N/A';
  }
  handleEdit(plan: IPlan){
    this.editPlan.emit(plan);
  }
}
